import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectSearchTerm as selectReviewSearchTerm, setSearchTerm as setReviewSearchTerm } from 'state/review'
import { selectIndividualPerformanceSearchTerm, setIndividualPerformanceSearchTerm } from 'state/campaignReport'
import {
    selectSearchTerm as selectAmbassadorSearchTerm,
    setSearchTerm as setAmbassadorSearchTerm,
} from 'state/ambassadors'
import { useIsMobileView, useNewTranslation } from 'hooks'
import Search from 'particles/Search'
import { TableViewType } from '.'

interface SearchBarProps {
    viewType?: TableViewType
}

const SearchBar: React.FC<SearchBarProps> = ({ viewType }) => {
    const [t] = useNewTranslation()
    const dispatch = useDispatch()
    const isMobileView = useIsMobileView()
    const reviewSearchTerm = useSelector(selectReviewSearchTerm)
    const individualPerformanceSearchTerm = useSelector(selectIndividualPerformanceSearchTerm)
    const ambassadorSearchTerm = useSelector(selectAmbassadorSearchTerm)

    const setSearch = (keywords: string | null): void => {
        if (keywords !== null) {
            if (viewType === TableViewType.INDIVIDUAL_PERFORMANCE) {
                dispatch(setIndividualPerformanceSearchTerm(keywords))
            } else if (viewType === TableViewType.AMBASSADOR) {
                dispatch(setAmbassadorSearchTerm(keywords))
            } else {
                dispatch(setReviewSearchTerm(keywords))
            }
        }
    }

    const onClearSearchTerm = () => {
        setSearch('')
    }

    return (
        <Search
            size="xs"
            {...(!isMobileView ? { width: '300px' } : null)}
            collapsible
            onClearSearch={onClearSearchTerm}
            onSearch={setSearch}
            searchValue={
                viewType === TableViewType.INDIVIDUAL_PERFORMANCE
                    ? individualPerformanceSearchTerm
                    : viewType === TableViewType.AMBASSADOR
                      ? ambassadorSearchTerm
                      : reviewSearchTerm
            }
            placeholder={t('placeholderText.enterNameUsername')}
        />
    )
}

export default SearchBar
